import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = {
	children: ReactNode
	onError: (error: Error, info: ErrorInfo) => void
}

/**
 * An error boundary that expects the parent company to correctly handle
 * switching from the erroring content to non-erroring content (an error page)
 */
export class NoOpErrorBoundary extends Component<Props> {
	componentDidCatch(error: Error, info: ErrorInfo) {
		const { onError } = this.props
		onError(error, info)
		// Suppress warning about not updating state. The user of the component
		// should avoid rerendering the errored component manually.
		this.setState(null)
	}

	render() {
		const { children } = this.props

		return children
	}
}
